module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Billing Expense Details ")])], 1), _vm._v(" "), (_vm.getSingleExpenseDeatils) ? _c('b-card', {
    staticClass: "formCard mb-2"
  }, [_c('b-card-text', [_c('div', [_c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', [_c('h5', {
    staticClass: "mt-4"
  }, [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Assignment Details : ")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Assignment No :\n                  "), _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.AssNo))])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Assignment Date :"), _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.AssDate))])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  MBLNO :"), _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.MBLNO))])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  HBLNO :"), _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.HBLNO))])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Sline :"), _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.shippingLine))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Client Name :\n                  "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.getSingleExpenseDeatils.clientName))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Location :"), _c('br'), _vm._v(" "), _c('span', [_vm._v("POR : "), _c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.POR))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("POL : "), _c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.POL))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("POD : "), _c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.POD))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("FPOD : "), _c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.FPOD))])]), _c('br')]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('b-col', [_c('h5', {
    staticClass: "mt-4"
  }, [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Expense Details : ")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Expense Type:\n                  "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.getSingleExpenseDeatils.docDtls_Typ))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Expense No:\n                  "), _c('span', [_c('b', [_c('u', [(_vm.getSingleExpenseDeatils.docDtls_No) ? _c('a', {
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "href": _vm.docURL + "/ASSIGNMENT_UPLOADS/Common_Invoices_doc/" +
        _vm.getSingleExpenseDeatils.docDtls_No.replaceAll('/', '_') +
        '.pdf',
      "target": "_blank",
      "download": ""
    }
  }, [_vm._v(_vm._s(_vm.getSingleExpenseDeatils.docDtls_No))]) : _vm._e()])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Expense Price:\n                  "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.getSingleExpenseDeatils.TotInvVal))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Expense Date :\n                  "), _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.Exp_Date))])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('b-col', [_c('h5', {
    staticClass: "mt-4"
  }, [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Buyer Details : ")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Buyer Name :\n                  "), _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.buyerName))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Buyer GST :\n                  "), _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.buyerGST))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Buyer Add :\n                  "), _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.buyerAdd))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Buyer State :\n                  "), _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.buyerState))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Buyer State Code :\n                  "), _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.buyerStateCode))])])]), _vm._v(" "), _c('br')])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', [_c('h5', {
    staticClass: "mt-4"
  }, [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Vendor Details : ")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Vendor Name :\n                  "), _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.vendorName))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Vendor GST :\n                  "), _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.vendorGST))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Vendor State/Code :\n                  "), _c('span', [_c('b', [_vm._v("\n                      " + _vm._s(_vm.getSingleExpenseDeatils.vendorState) + " /\n                      " + _vm._s(_vm.getSingleExpenseDeatils.vendorStateCode))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Vendor Addr/Pin :\n                  "), _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.vendorAdd))])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('b-col', [_c('h5', {
    staticClass: "mt-4"
  }, [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Shipper Details : ")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Shipper GST :\n                  "), _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.shipDtls_Gstin))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Shipper Name :\n                  "), _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.shipDtls_LglNm))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Shipper Addr/Pin :\n                  "), _c('span', [_c('b', [_vm._v("\n                      " + _vm._s(_vm.getSingleExpenseDeatils.shipDtls_Addr1) + " /\n                      " + _vm._s(_vm.getSingleExpenseDeatils.shipDtls_Pin))])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('b-col', [_c('h5', {
    staticClass: "mt-4"
  }, [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Others Details : ")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  INV No :\n                  "), _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.invoice_No_Date))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Shipper Bill No :\n                  "), _c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.getSingleExpenseDeatils.sBNO_BENo_Date))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n                  Weight :\n                  "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.getSingleExpenseDeatils.weight_CBM))])])]), _vm._v(" "), _c('br')])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', {
    staticClass: "mt-4 mb-2"
  }, [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Container Details : ")])], 1), _vm._v(" "), _c('b-row', [_c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n              Conatiner :\n              "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.getSingleExpenseDeatils.ExpContainersNo))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n              Sys Conatiner :\n              "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.getSingleExpenseDeatils.AssContainerNos))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n              Sys Container Type :\n              "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.getSingleExpenseDeatils.containerType))])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "box-body gutr mt-4"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "tpt"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Particulars")]), _vm._v(" "), _c('th', [_vm._v("Split Status")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("Barcode")]), _vm._v(" "), _c('th', [_vm._v("HSNCode")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("GST Rate")]), _vm._v(" "), _c('th', [_vm._v("IGST Amt")]), _vm._v(" "), _c('th', [_vm._v("CGST Amt")]), _vm._v(" "), _c('th', [_vm._v("SGST Amt")]), _vm._v(" "), _c('th', [_vm._v("Cest Rt/Amt")]), _vm._v(" "), _c('th', [_vm._v("Amt")]), _vm._v(" "), _c('th', [_vm._v("Total")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ExpenseItemDeatils), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.prdDesc) + "\n                    \n              \n                  ")]), _vm._v(" "), _c('td', [(item1.SplitStatus == 'YES') ? _c('b-button', {
      staticClass: "mt-1",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "variant": "outline-info",
        "size": "xs"
      },
      on: {
        "click": function($event) {
          _vm.showExpenseDet(
            item1,
            'Expense',
            2,
            _vm.getSingleExpenseDeatils.docDtls_No,
            _vm.getSingleExpenseDeatils.AssNo,
            'Exp'
          )
        }
      }
    }, [_vm._v(_vm._s(item1.SplitStatus))]) : _c('b', [_vm._v(_vm._s(item1.SplitStatus))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.barcde))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.hsnCd))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(item1.totAmt) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.gstRt))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(item1.igstAmt) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.cgstAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.sgstAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.cesRt) + " / " + _vm._s(item1.cesAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.assAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.totItemVal) + " " + _vm._s(item1.orgCntry))])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Amount + Tax = Total Amount ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.getSingleExpenseDeatils.AMT) + " + " + _vm._s(_vm.taxAmount) + " =\n                " + _vm._s(_vm.getSingleExpenseDeatils.TotInvVal) + "\n              ")])])]), _vm._v(" "), _c('b-modal', {
    ref: "otherTallyExpCharges-modal",
    attrs: {
      "id": "otherTallyExpCharges-modal",
      "title": _vm.modal_title + _vm.modal_JobNo,
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "tpt"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Particulars")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("Barcode")]), _vm._v(" "), _c('th', [_vm._v("HSNCode")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("GST Rate")]), _vm._v(" "), _c('th', [_vm._v("IGST Amt")]), _vm._v(" "), _c('th', [_vm._v("CGST Amt")]), _vm._v(" "), _c('th', [_vm._v("SGST Amt")]), _vm._v(" "), _c('th', [_vm._v("Cest Rt/Amt")]), _vm._v(" "), _c('th', [_vm._v("Amt")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("JOB")]), _vm._v(" "), _c('th', [_vm._v("JOB AMT")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ExpenseItemSplitList), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.PrdDesc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.Qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.Barcde))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.HsnCd))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(item1.TotAmt) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.GstRt))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(item1.IgstAmt) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.CgstAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.SgstAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.CesRt) + " / " + _vm._s(item1.CesAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.AssAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.TotItemVal) + " " + _vm._s(item1.OrgCntry))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.JOBNO))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.JOBAMT))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('center', [_c('b-button', {
    staticClass: "mt-1",
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.hideExpenseDet
    }
  }, [_vm._v("\n                      Close")])], 1)], 1)])])])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-473df3e0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/expense/tallyExpDetails.vue
// module id = 2582
// module chunks = 0